import { useEffect } from "react";
import ExamProctor from "../utils/examProctor";

/*
 * Equivalent of adding <script src="exam-proctor.js"></script> to a page.
 * Starts the webcam proctor when this page mounts and stops it (removing the
 * floating camera widget and releasing the camera) when the candidate
 * navigates to a different page — see utils/examProctor.js for why this
 * differs slightly from the original self-starting script.
 */
export default function ExamProctorWidget() {
  useEffect(() => {
    ExamProctor.start();
    return () => {
      ExamProctor.stop();
    };
  }, []);

  return null;
}
